import React, { useMemo } from 'react';
import { getLanguage, useLanguage } from 'assets/languages';
import URLS from 'constants/urls';

interface GuidelineWebViewModalProps {
  productId: number;
  temporaryKey: string;
  onClose: () => void;
  onConfirm: () => void;
}

const GuidelineWebViewModal: React.FC<GuidelineWebViewModalProps> = ({
  productId,
  temporaryKey,
  onClose,
  onConfirm,
}) => {
  const language = getLanguage();
  const languageHook = useLanguage();
  const languageTexts = { ...languageHook.common } as any;
  const cacheBusterVersion = useMemo(() => new Date().getTime(), []);

  const webViewUrl = `${URLS.WEB_VIEW.URL}/${language}/product/${productId}/guidelineRules?temporaryKey=${temporaryKey}&context=brand_iframe&v=${cacheBusterVersion}`;

  return (
    <div className="flex flex-col w-[480px] bg-white h-[90vh] rounded-2xl overflow-hidden">
      <div className="flex-1 overflow-scroll px-5 pt-5">
        <iframe
          src={webViewUrl}
          className="w-full h-full border-0"
          title={languageTexts.guideline_check_title}
        />
      </div>

      {/* 하단 고정 버튼 */}
      <div className="px-5 pb-5 pt-3 bg-white border-t">
        <button
          onClick={onConfirm}
          className="w-full bg-black text-white py-4 rounded text-[16px] font-medium hover:bg-gray-800 transition-colors"
        >
          {languageTexts.guideline_no_issue_confirmed}
        </button>
      </div>
    </div>
  );
};

export default GuidelineWebViewModal;
